import React from "react"
import styled from "@emotion/styled"
import { css } from "@emotion/core"
import Icons from "../../icons";

export const Root = styled.div`
  position: relative;
  display: grid;
  grid-gap: 1em;
  width: 100%;
`

export const SearchIcon = styled(Icons.Search)`
  width: 1em;
  pointer-events: none;
`

const focus = css`
  background: white;
  cursor: text;
  width: 5em;
`

const collapse = css`
  width: 0;
  cursor: pointer;
`

const expand = css`
  width: 6em;
  margin-left: -1.6em;
  padding-left: 1.6em;
`

export const Input = styled.input`
  width: 100%;
  outline: none;
  border: none;
  font-size: 1em;
  background: transparent;
  color: ${p => p.theme.colors.primary};
  margin-left: 10px;
  transition: ${props => props.theme.shortTrans};
  border-radius: ${props => props.theme.smallBorderRadius};
  {hightlight-next-line}
  ${props => (props.collapse ? collapse : expand)};
`

export const Form = styled.form`
  display: flex;
  align-items: center;
  width: 100%;

  svg {
    fill: ${p => p.theme.colors.primary};
  }
`

export const HitsWrapper = styled.div`
  display: ${props => (props.show ? `grid` : `none`)};
  max-height: 50vh;
  overflow: scroll;
  z-index: 2;
  -webkit-overflow-scrolling: touch;
  position: absolute;
  left: 0;
  top: calc(100% + 0.5em);
  width: 80vw;
  max-width: 30em;
  box-shadow: 0 0 7px 0 rgba(0, 0, 0, 0.21);
  border-radius: 10px;
  padding: 1.5em;
  background: white;
  border-radius: ${props => props.theme.smallBorderRadius};
  > * + * {
    // padding-top: 1em !important;
  }
  li + li {
    margin-top: 0.7em;
  }
  * {
    margin-top: 0;
    padding: 0;
  }
  ul {
    list-style: none;
    margin-bottom: 1.3em;
  }
  mark {
    color: ${props => props.theme.lightBlue};
    background: ${props => props.theme.darkBlue};
  }
  header {
    display: flex;
    justify-content: space-between;
    margin-bottom: 0.2em;
    font-size: 10px;
    font-weight: bold;

    span {
      opacity: 0.5;
      display: flex;
      align-items: center;
    }

    h3 {
      background: ${props => props.theme.gray};
      padding: 0.1em 0.4em;
      padding-left: 0px;
      font-size: initial;
      font-weight: initial;
      border-radius: ${props => props.theme.smallBorderRadius};
    }
  }
  .no-results {
    opacity: 0.5;
    margin-bottom: 1.3em;
  }
  h3 {
    margin: 0 0 0.5em;
  }
  h4 {
    font-weight: normal;
    color: black;
    opacity: 0.5;

    &:hover {
      opacity: 1;
    }
  }
`;